"use client"
import Link from 'next/link';
import {  FaThLarge, } from 'react-icons/fa';
import { usePathname, useRouter } from 'next/navigation';
import { GoHome, GoHomeFill } from "react-icons/go";
import { FaWhatsapp } from "react-icons/fa";
import { RiPagesFill } from "react-icons/ri";
import { BiSolidContact } from "react-icons/bi";
import { BsFillInfoSquareFill, BsShop } from 'react-icons/bs';
import { FaShop } from 'react-icons/fa6';
export default function BottomNav() {
  const pathName = usePathname();
  const router = useRouter();

  return (
    <div className='bg-black'>
    <span className=' bg-darkBlack p-2 fixed  bottom-20 z-50 rounded-full hover:scale-95 right-6 hover:cursor-pointer' onClick={()=>router.push("https://wa.link/kc3woe")}> 
    <FaWhatsapp className="h-12 w-12 text-green-500 font-bold  " />
    </span>
    <div className=" sm:hidden fixed bottom-0  left-0 right-0  border-t z-50 border-gray-200 bg-darkBlack shadow-xl shadow-gray-500">
      <nav className="flex justify-around py-2">
        {/* Home Tab */}
        <a href="/" className={`${pathName === '/' ? 'text-blue-500  font-bold ' : ''} flex flex-col items-center text-pureWhite hover:text-blue-500`}>
        {
          pathName == "/" ? <GoHomeFill  className="h-6 w-6 "/> : < GoHome className="h-6 w-6 " />
        }
       
        <span className="text-sm">Home</span>
          </a>
        <a href="/products" className={`${pathName === '/products' ? 'text-blue-500  font-bold ' : ''} flex flex-col text-pureWhite items-center hover:text-blue-500`}>
        <FaShop  className="h-6 w-6 " />
        <span className="text-sm">Products</span>
          </a>
        <a href="/about" className={`${pathName === '/about' ? 'text-blue-500  font-bold ' : ''} flex flex-col items-center text-pureWhite hover:text-blue-500`}>
        <BsFillInfoSquareFill  className="h-6 w-6 text-pureWhite" />
        <span className="text-sm">About</span>
          </a>
        <a href="/contact" className={`${pathName === '/contact' ? 'text-blue-500  font-bold ' : ''} flex flex-col items-center text-pureWhite hover:text-blue-500`}>
        <BiSolidContact className="h-6 w-6 " />
        <span className="text-sm">Contact</span>
          </a>
        
      </nav>
    </div>
    </div>

  );
}
